import { ArtemSpinner } from '@/common'

export default function LoadingScreen() {
  return (
    <div className="flex items-center justify-center py-20">
      <ArtemSpinner className="h-40" />
    </div>
  )
}
